/* Algolia-powered /search results page (Route 2).
   Queries the Algolia products index for ranked handles, then renders each result as
   the REAL Horizon product card fetched via /products/<handle>?view=cardfragment.
   Keeps Algolia's relevance/ordering while reusing the theme's exact card markup/CSS. */
(function () {
  'use strict';

  var root = document.querySelector('[data-cpap-search-page]');
  if (!root) return;

  var grid = root.querySelector('[data-srch-grid]');
  var countEl = root.querySelector('[data-srch-count]');
  var moreBtn = root.querySelector('[data-srch-more]');
  var loadingEl = root.querySelector('[data-srch-loading]');
  var emptyEl = root.querySelector('[data-srch-empty]');

  var APP = root.dataset.algoliaApp;
  var KEY = root.dataset.algoliaKey;
  var INDEX = root.dataset.algoliaIndex;
  var PER = parseInt(root.dataset.perPage, 10) || 12;

  var query = (new URLSearchParams(window.location.search).get('q') || '').trim();
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var page = 0;
  var total = 0;
  var cardCache = {};

  // --- Algolia ---
  function algolia(q, pageN) {
    // clickAnalytics:true is required for Algolia to return a queryID — without it, click/
    // conversion events can't be tied back to the search that produced them.
    var as = window.algoliaShopify;
    if (as && as.searchClient && typeof as.searchClient.search === 'function') {
      return as.searchClient
        .search([{ indexName: INDEX, query: q, params: { hitsPerPage: PER, page: pageN, clickAnalytics: true } }])
        .then(function (r) { return r.results[0]; })
        .catch(function () { return null; });
    }
    var url = 'https://' + APP + '-dsn.algolia.net/1/indexes/*/queries'
      + '?x-algolia-application-id=' + APP + '&x-algolia-api-key=' + KEY;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: JSON.stringify({ requests: [{ indexName: INDEX, query: q, params: 'hitsPerPage=' + PER + '&page=' + pageN + '&clickAnalytics=true' }] })
    })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (d) { return d && d.results && d.results[0]; })
      .catch(function () { return null; });
  }

  // --- Fetch one real Horizon card (cached) ---
  function fetchCard(handle) {
    if (cardCache[handle]) return Promise.resolve(cardCache[handle].cloneNode(true));
    var url = routeRoot.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '?view=cardfragment';
    return fetch(url)
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-card-link') || doc.querySelector('product-card');
        if (!card) return null;
        cardCache[handle] = card.cloneNode(true);
        return card;
      })
      .catch(function () { return null; });
  }

  function setLoading(on) { loadingEl.hidden = !on; }

  function renderPage(append) {
    setLoading(true);
    moreBtn.disabled = true;
    return algolia(query, page).then(function (res) {
      setLoading(false);
      moreBtn.disabled = false;
      if (!res) { if (!append) showEmpty(); return; }

      total = res.nbHits || 0;
      var hits = res.hits || [];

      if (!append && hits.length === 0) { showEmpty(); return; }
      emptyEl.hidden = true;

      countEl.textContent = total + (total === 1 ? ' result' : ' results');

      var queryID = res.queryID;

      return Promise.all(hits.map(function (h) { return fetchCard(h.handle); }))
        .then(function (cards) {
          cards.forEach(function (card, i) {
            if (!card) return;
            var li = document.createElement('li');
            li.className = 'cpap-srch-item';
            if (queryID && hits[i] && hits[i].objectID) {
              li.setAttribute('data-algolia-query-id', queryID);
              li.setAttribute('data-algolia-object-id', hits[i].objectID);
              li.setAttribute('data-algolia-position', String(page * PER + i + 1));
            }
            li.appendChild(card);
            grid.appendChild(li);
          });
          // Show "load more" if more pages remain
          var shown = (page + 1) * PER;
          moreBtn.hidden = shown >= total;
        });
    });
  }

  function showEmpty() {
    grid.innerHTML = '';
    countEl.textContent = '';
    moreBtn.hidden = true;
    emptyEl.hidden = false;
  }

  moreBtn.addEventListener('click', function () {
    page += 1;
    renderPage(true);
  });

  // Click tracking — fire-and-forget, never blocks the real navigation to the product page.
  grid.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    var li = e.target.closest('.cpap-srch-item[data-algolia-object-id]');
    if (!li || !window.cdwAlgoliaInsights) return;
    window.cdwAlgoliaInsights.recordClick(
      li.getAttribute('data-algolia-query-id'),
      li.getAttribute('data-algolia-object-id'),
      parseInt(li.getAttribute('data-algolia-position'), 10)
    );
  });

  if (!query) { showEmpty(); return; }
  renderPage(false);
})();
